import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Table } from 'antd';

import { Default } from '../../../../layouts';

import useDatasource from '../../../../hooks/useDatasource';
import {
  deleteUserType,
  getUserTypesLight,
} from '../../../../services/taxonomies/user-types';

import PageTitle from '../../../../components/PageTitle';
import AddEntityButton from '../../../../components/buttons/AddEntityButton';
import EditItemIcon from '../../../../components/buttons/EditItemIcon';
import DeleteItemIcon from '../../../../components/buttons/DeleteItemIcon';
import Column from '../../../../helpers/columns';
import usePermissions from '../../../../hooks/usePermission';
import ViewItemIcon from '../../../../components/buttons/ViewItemIcon';

const permissionsMap = {
  canView: ['ADMINISTRATION_TAXONOMIES_VIEW_PERMISSION'],
  canEdit: ['SYS_SUPERUSER', 'TAXONOMIES_PERMISSION'],
  canDelete: ['SYS_SUPERUSER', 'TAXONOMIES_PERMISSION'],
};

const UserTypesList = () => {
  const { t } = useTranslation();
  const { canView, canEdit, canDelete } = usePermissions(permissionsMap);
  const { pagination, content, handleChange, reload } =
    useDatasource(getUserTypesLight);

  const columns = useMemo(
    () => [
      Column.text('name', t('entity.taxonomy.userType.name'), { filter: true }),
      Column.text('description', t('entity.taxonomy.userType.description'), {
        filter: true,
      }),
      Column.bool('deleted', t('entity.taxonomy.userType.deleted._'), {
        width: 150,
        filter: true,
        inverted: true,
        labels: [
          t('table.filter.all'),
          t('entity.taxonomy.userType.deleted.true'),
          t('entity.taxonomy.userType.deleted.false'),
          t('table.filter.unknown'),
        ],
      }),
      Column.actions(t('table.actions'), (record) => (
        <>
          {canView && (
            <ViewItemIcon path={`/admin/taxonomies/user-types/${record.id}`} />
          )}
          {canEdit && (
            <EditItemIcon path={`/admin/taxonomies/user-types/${record.id}`} />
          )}
          {canDelete && (
            <DeleteItemIcon
              title={t('entity.taxonomy.userType._delete', record)}
              message={t('entity.taxonomy.userType._deleted', record)}
              item={record}
              action={deleteUserType}
              reload={reload}
            />
          )}
        </>
      )),
    ],
    [t, canView, canEdit, canDelete, reload],
  );

  return (
    <Default>
      <PageTitle title={t('entity.taxonomy.userType._plural')}>
        {canEdit && (
          <AddEntityButton
            entity={t('entity.taxonomy.userType._singular')}
            path="/admin/taxonomies/user-types/new"
          />
        )}
      </PageTitle>
      <Table
        columns={columns}
        rowKey="id"
        // loading={loading}
        pagination={pagination}
        dataSource={content}
        onChange={handleChange}
        scroll={{ x: 700, y: 700 }}
      />
    </Default>
  );
};

export default UserTypesList;
